import { motion } from 'framer-motion';
import { useReducedMotion } from '../../hooks/useReducedMotion';
import { hudCopy } from '../content';
import { DataRing, HudPanel, MetricBar, ModuleHeader, ScannerOverlay, SignalChart, SystemFrame } from '../primitives';

export const AutomationMatrixScreen = () => {
  const reducedMotion = useReducedMotion();

  return (
    <SystemFrame id="automation-matrix" className="min-h-[calc(100vh-6.5rem)] pt-24">
      <HudPanel pulse className="relative">
        <ScannerOverlay tone="intense" />
        <ModuleHeader
          index="SCREEN 04"
          title={hudCopy.automation.heading}
          subtitle={hudCopy.automation.subtitle}
          tag="INTELLIGENCE LAYER"
          status={hudCopy.microLabels.signal}
        />

        <div className="mt-7 grid gap-4 lg:grid-cols-[1.25fr_0.75fr]">
          <HudPanel pulse className="relative overflow-hidden bg-brand-panel-2/72">
            <p className="hud-micro text-brand-lime">Automation Channels</p>
            <div className="mt-4 space-y-3">
              {hudCopy.automation.modules.map((module, index) => (
                <article key={module.title} className="rounded-xl border border-brand-lime/22 bg-brand-panel/68 px-4 py-3">
                  <div className="flex items-center justify-between gap-3">
                    <h3 className="text-base font-semibold text-brand-text">{module.title}</h3>
                    <div className="flex items-center gap-2">
                      <motion.span
                        className="h-2.5 w-2.5 rounded-full bg-brand-lime"
                        animate={reducedMotion ? undefined : { opacity: [0.35, 1, 0.45], scale: [0.8, 1.25, 0.9] }}
                        transition={{ duration: 1.6, repeat: Infinity, delay: index * 0.2 }}
                      />
                      <span className="text-xl font-semibold text-brand-lime">{module.stat}</span>
                    </div>
                  </div>
                  <p className="mt-2 text-sm text-brand-text-2">{module.body}</p>
                  <div className="mt-4">
                    <MetricBar label="Activation Level" value={Math.min(96, 64 + module.stat.length * 5)} />
                  </div>
                </article>
              ))}
            </div>

            <motion.div
              className="pointer-events-none absolute inset-y-0 left-[-18%] w-[18%] bg-[linear-gradient(90deg,transparent,rgba(88,247,182,0.26),transparent)]"
              animate={reducedMotion ? undefined : { x: ['0%', '660%'] }}
              transition={{ duration: 3.8, repeat: Infinity, ease: 'linear' }}
            />
          </HudPanel>

          <div className="space-y-4">
            <HudPanel pulse className="bg-brand-panel-2/72">
              <p className="hud-micro text-brand-lime">AI Signal Radials</p>
              <div className="mt-4 grid grid-cols-3 gap-2">
                <DataRing value={81} label="Flow" size={86} />
                <DataRing value={74} label="Model" size={86} />
                <DataRing value={89} label="Control" size={86} />
              </div>
            </HudPanel>
            <HudPanel pulse className="bg-brand-panel-2/72">
              <p className="hud-micro text-brand-lime">Routing Activity</p>
              <div className="mt-3">
                <SignalChart points={[29, 37, 48, 42, 55, 65, 59, 77, 71, 86]} />
              </div>
            </HudPanel>
          </div>
        </div>
      </HudPanel>
    </SystemFrame>
  );
};
